import request from "../../../../core/data/network/client/request";
import Api from "../../../../core/data/network/constants/api_routes";

export default {
  cancelCompressJob: async (data) => {
    return request.post(Api.cancelCompressJob(), data);
  },
  updateAnalisysType: async (docId, data) => {
    return request.put(Api.updateAnalisysType(docId), data);
  },
  getRetrieveAnnexes: async (data) => {
    return request.get(Api.getRetrieveAnnexes(data));
  },
  getRetrieveUserCompressions: async () => {
    return request.get(Api.getRetrieveUserCompressions());
  },
};
